import { ColumnMetadata } from "@valg-shared/components/table/table/column-metadata";
import { TableDataItem } from "@valg-shared/components/table/table/table.component";
import { WithPropsOfType } from "@valg-shared/forms";

export interface MandatesList extends TableDataItem {
  candidateList: string;
  numberOfMandates: number;
}

export const MandatesListColumnDef: WithPropsOfType<MandatesList, ColumnMetadata> = {
  candidateList: {
    title: 'mandates_list.column.candidateList'
  },
  numberOfMandates: {
    title: 'mandates_list.column.number_of_mandates',
    rightAligned: true
  },
  id: { title: 'id', disable: true },
};
